import moment from "moment";
import {
  getFileDisplayName,
  getFileKindKey,
} from "../../sections/SharedFilesSection/fileTypes";

// One-line plain-text preview of a message's HTML content
export const getMessagePreview = (html) => {
  if (!html) return "";
  const text = new DOMParser().parseFromString(html, "text/html").body
    .textContent;
  return text.replace(/\s+/g, " ").trim();
};

// A chat's latest message for its list row. Attachments get an icon ("📷 Photo", "🎥 Video", else
// "📎 file name") ahead of the caption, or in place of it when there is none; polls read "📊 Poll".
export const getLatestMessagePreview = (chat) => {
  const text = getMessagePreview(chat?.latestMessage);
  if (chat?.latestMessageIsPoll) return text ? `📊 ${text}` : "📊 Poll";
  if (!chat?.latestMessageFile) return text;

  const name = getFileDisplayName(chat.latestMessageFile);
  const extension = name.includes(".") ? name.split(".").pop() : "";
  const kind = getFileKindKey(extension);
  const icon = kind === "image" ? "📷" : kind === "video" ? "🎥" : "📎";
  if (text) return `${icon} ${text}`;

  const label = kind === "image" ? "Photo" : kind === "video" ? "Video" : name;
  const more = chat.latestMessageFileCount > 1 ? ` +${chat.latestMessageFileCount - 1}` : "";
  return `${icon} ${label}${more}`;
};

// List times: "12:42 PM" today, "Yesterday", the weekday this week, else the date
export const formatListTime = (date) => {
  if (!date) return "";
  const time = moment(date);
  if (!time.isValid()) return "";
  if (time.isSame(moment(), "day")) return time.format("hh:mm A");
  if (time.isSame(moment().subtract(1, "day"), "day")) return "Yesterday";
  if (time.isAfter(moment().subtract(6, "days"), "day")) return time.format("ddd");
  return time.format("DD/MM/YY");
};
